export default {
      id: "mission-report-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#mission-report",
      toString: function () {
        return this.url;
      }
    }